<template>
    <SwipeModalComponent v-if="deleteItemMenu.isVisible" @closeMenu="changeDeleteItemVisibility">
        <div class="content-wrapper">
            <h2 v-text="itemName"></h2>

            <div class="deleteButton" @click="emitEvent(itemName)">
                <button class="fa fa-trash fa-2xl"></button>
            </div>
        </div>
    </SwipeModalComponent>
</template>
<script >
import SwipeModalComponent from './SwipeModalComponent.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'DeletItemComponent',
    emits: ['deleteEvent'],
    components: {
        SwipeModalComponent
    },
    props: ['itemName'],
    data () {
        return {}
    },
    computed: {
        ...mapGetters(['deleteItemMenu'])
    },
    methods: {
        ...mapActions(['changeDeleteItemVisibility']),
        emitEvent: function (item) {
            this.$emit('deleteEvent', item)
        }
    }
}
</script>
<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    h2 {
        text-align: center;
        &:last-of-type {
            margin-bottom: 40px;
        }
    }

    .deleteButton {
        background-color: var(--primaryColor);
        width: 60px;
        height: 60px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0px auto 40px auto;
    }

    button {
        text-align: right;
        color: #FFF;
        border: none;
        background-color: transparent;
    }
}
</style>
